const GTM_ITEM_CATEGORIES = {
  addon: 'Dodatek',
  diet: 'Dieta',
  dish: 'Danie',
};

export default GTM_ITEM_CATEGORIES;
